import React, { useState, useEffect } from "react";
import Radialchart from "./RadialChart";
import RadialChartServices from "./RadialChartServices";
import "./AccountSummary.css";
import {
  formatToIndianRupees,
  formatDate,
  getdata,
  getAccountSummary
} from "../../Global/Index";
import Cookies from "js-cookie";
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from "react-toastify";
import LoanTimeLine from "./LoanTimeLine";
import { useTheme } from "@mui/material";

const override = {
  display: "block",
  margin: "10% auto",
  marginLeft: "50%",
};

export default function AccountSummary() {
  const [data, setData] = useState(null);
  const [tenuredata, setTenuredata] = useState(null);
  const [interestData, setInterestData] = useState(null);
  const [loanDetailListData, setLoanDetailListData] = useState(null);

  const theme = useTheme();

  let Mobile_Number = null;
  let OppertunityId = null;
  const encoded_token = Cookies.get("token");

  const toCamelCase = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };


  useEffect(() => {
    const getdatafunction = async () => {
      const data = await getdata();
      // console.log(`response of getdata function is ${JSON.stringify(data)}`)
      if (data.response.status == '200') {
        Mobile_Number = data.response.data.MobileNumber;
        OppertunityId = data.response.data.OpportunityId;
      } else if (data.response.status === "503") {
        toast.warn(data.response.message);
      }
    }

    getdatafunction()
  }, [])


  useEffect(() => {

    const getdata = async () => {

      try {
        const reponsedata = await getAccountSummary();
        const data = reponsedata.response?.data;
        if (reponsedata.response?.status === "200") {
          const loan = data.dashboardData?.loanList?.find(loan => loan.oppertunityId === OppertunityId);
          if (loan) {
            setData(loan);
          }
          setTenuredata(data.tenureData);
          // console.log(`loan detail are : ${JSON.stringify(data.loanDetails)}`);
          setLoanDetailListData(data.loanDetails);
          if (data.provisionalCertificate) {
            setInterestData(data.provisionalCertificate);
          } else {
            setData([]);
          }
        } else if (reponsedata.response.status === "419") {
          window.location.href = '/Session-Expired';
        } else if (reponsedata.response.status === "500") {
          toast.error('Something went wrong. Please try again later!');
        } else if (reponsedata.response.status == "401") {
          window.location.href = '/';
        }
      } catch (error) {
        console.log(error)
      }
    }

    getdata();
  }, [Mobile_Number, encoded_token])


  const renderLoanDetails = () => {
    if (!data || !loanDetailListData) return null;

    return (
      <div className="mainsubcontainer">
        <div className="upperleftpart">
          <div className="leftaccountsummary" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <div>
              {renderLoanDetail("Borrower", toCamelCase(data.LoanAccountName))}
              {renderLoanDetail("Rate of Interest", loanDetailListData?.[0]?.effectiveRateOfInterest ? `${loanDetailListData[0].effectiveRateOfInterest} %` : "NA")}
              {renderLoanDetail("EMI Due Date", loanDetailListData[0]?.emiDueDate ? formatDate(loanDetailListData[0].emiDueDate) : "NA")}
              {renderLoanDetail("Loan Amount", loanDetailListData[0]?.sanctionAmount ? formatToIndianRupees(loanDetailListData[0].sanctionAmount) : "NA")}
              {renderLoanDetail("Loan Status", loanDetailListData[0]?.loanStatus || "NA")}
              {renderLoanDetail("Principal & Interest Paid", interestData ? `${formatToIndianRupees(interestData.receivedprincipal)} & ${formatToIndianRupees(interestData.receivedinterest)}` : "NA")}
            </div>

            <div>
              {renderLoanDetail("Loan Type", data.Loantype || "NA")}
              {renderLoanDetail("Term", loanDetailListData[0]?.term ? `${loanDetailListData[0].term} Months` : "NA")}
              {renderLoanDetail("Monthly EMI", loanDetailListData[0]?.emiAmount ? formatToIndianRupees(loanDetailListData[0].emiAmount) : "NA")}
              {renderLoanDetail("First Disbursement Date", data?.timeline?.Disbursementdate ? formatDate(data.timeline.Disbursementdate) : "NA")}
              {renderLoanDetail("Last Payment Date", loanDetailListData[0]?.lastPaymnetdate ? formatDate(loanDetailListData[0].lastPaymnetdate) : "NA")}
            </div>
          </div>

          <div className="rightaccountsummary">
            <div style={{ border: "1px solid lightgray", borderRadius: ".4vw", padding: "2vh 4vh" }}>
              <LoanTimeLine history={data.timeline} />
            </div>
          </div>
        </div>

        {
          (data && ((data.CompletedServiceRequest > 0 && data.PendingServiceRequest > 0)) || (tenuredata?.balancetenure && data?.Term > 0)) && <hr />
        }
        <div className="serviceAndTenureGraphs">
          {renderServiceRequests()}
          {renderLoanTenure()}
        </div>

      </div>
    );
  };

  const renderLoanDetail = (label, value) => (
    <div className="distance">
      <h4>{label}</h4>
      <p>{value || "NA"}</p>
    </div>
  );

  const renderServiceRequests = () => {
    if (data && data.CompletedServiceRequest > 0 && data.PendingServiceRequest > 0) {
      return (
        <div>
          <h4 style={{ marginBottom: "2vh", marginTop: "4vh" }} className='graphheader'>Service Requests</h4>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <RadialChartServices
              data={{
                PendingServiceRequest: data.PendingServiceRequest,
                CompletedServiceRequest: data.CompletedServiceRequest,
              }}
            />
          </div>
        </div>
      );
    }
    return null;
  };

  const renderLoanTenure = () => {
    if (tenuredata?.balancetenure && data.Term > 0) {
      return (
        <div>
          <h4 style={{ marginBottom: "2vh", marginTop: "4vh" }} className='graphheader'>Loan Tenure ( in Months )</h4>
          <div style={{ display: "flex", justifyContent: "center", paddingBottom: '2vh' }}>
            <Radialchart
              data={{
                balancetenure: tenuredata.balancetenure,
                term: data.Term,
              }}
            />
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <ToastContainer />
      <div className="maincontainer" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
        <h2>Account Summary</h2>
        {data && loanDetailListData ? renderLoanDetails() : (
          <ClipLoader
            color={theme.palette.maincolor.light}
            loading={true}
            cssOverride={override}
            size={30}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        )}
      </div>
    </>
  );
}